import { useRefinementList } from "react-instantsearch";

export const useGender = () => {
  const { items, refine } = useRefinementList({ attribute: "gender" });
  const man = items.find((i) => i.value.toLowerCase() === "man");
  const woman = items.find((i) => i.value.toLowerCase() === "woman");

  const toggleGroup = (group: string) => {
    refine(group);

    if (group.toLowerCase() === "man" && !woman?.isRefined) {
      refine("Unisex");
      refine("Not applicable");
    } else if (group.toLowerCase() === "woman" && !man?.isRefined) {
      refine("Unisex");
      refine("Not applicable");
    }
  };

  return {
    toggleGroup,
    items,
    itemsFilterRule: (g: any) =>
      g.value !== "Not applicable" && g.value !== "Unisex",
  };
};
